import { testimonialList } from "@/mocks/manga";

export default function Testimonials() {
  return (
    <section id="voices" className="bg-background-100 py-16 md:py-24">
      <div className="mx-auto max-w-7xl px-4 md:px-6">
        <div className="mx-auto max-w-2xl text-center">
          <span className="inline-flex items-center gap-2 rounded-full bg-accent-100 px-4 py-1.5 text-sm font-medium text-accent-800">
            <i className="ri-chat-3-line"></i>
            用户口碑
          </span>
          <h2 className="mt-4 font-heading text-3xl text-foreground-950 md:text-4xl">
            百万读者的阅读搭子
          </h2>
          <p className="mt-4 text-foreground-700">
            从通勤到睡前，尾巴漫画网陪着无数人在不同设备间无缝追更，听听他们怎么说。
          </p>
        </div>

        <div className="mt-12 grid grid-cols-1 gap-6 md:grid-cols-3">
          {testimonialList.map((item) => (
            <figure
              key={item.id}
              className="flex flex-col rounded-2xl border border-background-200 bg-background-50 p-6"
            >
              <i className="ri-double-quotes-l text-3xl text-primary-300"></i>
              <blockquote className="mt-3 flex-1 text-sm leading-relaxed text-foreground-700">
                {item.quote}
              </blockquote>
              <figcaption className="mt-5 flex items-center gap-3 border-t border-background-200 pt-4">
                <img
                  src={item.avatar}
                  alt={`${item.name}的头像`}
                  className="h-11 w-11 rounded-full object-cover"
                />
                <div>
                  <div className="font-medium text-foreground-950">{item.name}</div>
                  <div className="text-xs text-foreground-500">{item.role}</div>
                </div>
              </figcaption>
            </figure>
          ))}
        </div>
      </div>
    </section>
  );
}